import React from 'react';
import { Building2, CreditCard, Truck, ShoppingCart } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function BenefitsTicker() {
  const {
    t
  } = useTranslations();
  const benefits = [t('ticker.approval'), t('ticker.fastApprovals'), t('ticker.noUpfront'), t('ticker.softCredit'), t('ticker.sameDay')];
  // Duplicate for seamless marquee
  const marqueeItems = [...benefits, ...benefits, ...benefits, ...benefits];
  return <div className="w-full bg-white pb-4" data-id="element-16">
      {/* Scrolling Ticker */}
      <div className="w-full border-y border-gray-100 py-3 overflow-hidden relative flex bg-white" data-id="element-17">
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-18">
          {marqueeItems.map((benefit, index) => <div key={index} className="flex items-center mx-6" data-id="element-19">
              <div className="w-1.5 h-1.5 rounded-full bg-[#00E676] mr-3" data-id="element-20"></div>
              <span className="text-sm font-semibold text-gray-800" data-id="element-21">
                {benefit}
              </span>
            </div>)}
        </div>
      </div>

      {/* Funding Result Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-22">
        <h3 className="text-xl font-bold text-gray-900 text-center mb-4" data-id="element-23">
          Últimas Aprobaciones
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-24">
          {/* Card 1 */}
          <div className="bg-white border border-gray-100 rounded-xl p-4 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-25">
            <div className="w-10 h-10 rounded-lg bg-red-500 flex items-center justify-center flex-shrink-0" data-id="element-26">
              <Building2 className="w-5 h-5 text-white" data-id="element-27" />
            </div>
            <div data-id="element-28">
              <p className="text-lg font-bold text-gray-900 leading-tight" data-id="element-29">
                $250,000
              </p>
              <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-30">
                Construction Co. | Cash Advance
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white border border-gray-100 rounded-xl p-4 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-31">
            <div className="w-10 h-10 rounded-lg bg-teal-500 flex items-center justify-center flex-shrink-0" data-id="element-32">
              <CreditCard className="w-5 h-5 text-white" data-id="element-33" />
            </div>
            <div data-id="element-34">
              <p className="text-lg font-bold text-gray-900 leading-tight" data-id="element-35">
                $75,000
              </p>
              <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-36">
                New LLC | 0% Interest Credit Card
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white border border-gray-100 rounded-xl p-4 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-37">
            <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-38">
              <Truck className="w-5 h-5 text-white" data-id="element-39" />
            </div>
            <div data-id="element-40">
              <p className="text-lg font-bold text-gray-900 leading-tight" data-id="element-41">
                $120,000
              </p>
              <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-42">
                Logistics Business | Working Capital
              </p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-white border border-gray-100 rounded-xl p-4 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-43">
            <div className="w-10 h-10 rounded-lg bg-purple-500 flex items-center justify-center flex-shrink-0" data-id="element-44">
              <ShoppingCart className="w-5 h-5 text-white" data-id="element-45" />
            </div>
            <div data-id="element-46">
              <p className="text-lg font-bold text-gray-900 leading-tight" data-id="element-47">
                $180,000
              </p>
              <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-48">
                E-commerce Brand | Line of Credit
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}